<template>
  <v-sheet color="adawhite" style="min-height:100vh;box-sizing:border-box;">
    <v-container style="max-width:750px;" class="pt-16">
      <GenericNav />

      <HelloWidget :Usergreeting="Usergreeting" class="d-sm-none" />

      <div style="display:flex;flex-flow:row;">
        <div
          style="
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          flex-grow: 4;
          "
        >
          <transition-group name="slide-x-transition" appear>
            <template v-if="Foods.length > 0">
              <NFoodCard v-for="food in Foods" :key="food.id" :food="food" />
            </template>
            <template v-else-if="!SDKError">
              <v-progress-circular
                size="70"
                :width="7"
                indeterminate
                color="nsecondary"
                class="mx-auto"
                :key="1"
              />
            </template>
            <template v-else>
              <v-alert tile :key="1" type="error" rounded="lg">
                SDK-virhe: {{ SDKError }}
                <v-btn
                  class="mx-2 primary--text"
                  depressed
                  color="nwhite"
                  @click="refresh"
                >
                  <v-icon left dark>mdi-cached</v-icon>Yritä uudelleen
                </v-btn>
              </v-alert>
            </template>
          </transition-group>
        </div>
        <div class="pl-4 d-none d-sm-block">
          <HelloWidget :Usergreeting="Usergreeting" isCard />
          <v-container>
            <v-btn block to="/" class="my-2" rounded dark color="nsecondary">
              <v-icon dark>mdi-ab-testing</v-icon>
              Now in Canary
            </v-btn>
            <v-btn
              block
              to="settings"
              class="my-2"
              rounded
              dark
              color="nsecondary"
            >
              <v-icon dark>mdi-cog</v-icon>
            </v-btn>
          </v-container>
          <transition-group name="slide-x-reverse-transition" appear>
            <template v-if="Ads && Ads.length > 0">
              <NAdCollection v-for="ad in Ads" :key="ad.title" :ad="ad" />
            </template>
            <template v-else-if="AdSDKError">
              <v-alert tile key="1" type="error" rounded="lg">
                SDK-virhe: {{ AdSDKError }}
              </v-alert>
            </template>
          </transition-group>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import GenericNav from "@/components/layout/GenericNav";
import NFoodCard from "@/components/NFoodCard";
import NAdCollection from "@/components/NAdCollection";
import HelloWidget from "@/components/HelloWidget";

export default {
  name: "Home",
  components: {
    GenericNav,
    NFoodCard,
    NAdCollection,
    HelloWidget
  },
  computed: {
    Usergreeting() {
      return this.$store.getters["appconfig/getPersonalGreeting"];
    },
    ...mapState({
      Foods: state => state.foods.current,
      SDKError: state => state.foods.sdkerror,
      Ads: state => state.marketing.ads,
      AdSDKError: state => state.marketing.sdkerror
    })
  },
  created() {
    this.$store.dispatch("foods/getCurrentFoods");
    this.$store.dispatch("marketing/getAllAds");
  },
  methods: {
    refresh() {
      this.$store.dispatch("foods/getCurrentFoods");
      this.$store.dispatch("marketing/getAllAds");
    }
  }
};
</script>
